export default {
  namespaced: true,
  state: {
    aberto: false,
    finalizacaoPedido: false,
    finalizacaoCompraResponsivo: false
  },
  getters: {
    sidebarOpen (state) {
      return state.aberto
    }
  },
  mutations: {
    toggleMenu (state, payload) {
      state.aberto = payload
    },
    finalizacaoPedido (state, payload) {
      state.finalizacaoPedido = payload
    },
    finalizacaoCompraResponsivo (state, payload) {
      state.finalizacaoCompraResponsivo = payload
    }
  },
  actions: {
    toggleMenu ({ commit }, payload) {
      commit('toggleMenu', payload)
    },
    finalizacaoPedido ({ commit }, payload) {
      commit('finalizacaoPedido', payload)
    },
    finalizacaoCompraResponsivo ({ commit }, payload) {
      commit('finalizacaoCompraResponsivo', payload)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/menu.js